import React from "react";
import Nav from "./Nav";
import Footer from "./Footer";

/**
 * Shared shell for every public page (landing, /demo, /pricing).
 * Page content sits between sticky Nav and Footer on a light surface.
 */
export const PageShell = ({ children, testid }) => {
    return (
        <div
            data-testid={testid || "page-shell"}
            className="min-h-screen flex flex-col bg-[#f6f7f6] text-[#0e1416]"
        >
            <Nav />
            <main className="flex-1">{children}</main>
            <Footer />
        </div>
    );
};

export default PageShell;
